import { render } from "./GradeBook.vue?vue&type=template&id=bda82770&scoped=true"
import script from "./GradeBook.vue?vue&type=script&lang=js"
export * from "./GradeBook.vue?vue&type=script&lang=js"

import "./GradeBook.vue?vue&type=style&index=0&id=bda82770&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda82770"]])

export default __exports__